import { LANDING_PAGE_REQUEST, LANDING_PAGE_SUCCESS, LANDING_PAGE_FAILURE } from './types';
import { parseComponentTree } from './factories';

const initialState = {
  loading: false,
};

export default function landingPageReducer(state = initialState, action = {}) {
  switch (action.type) {
    case LANDING_PAGE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LANDING_PAGE_SUCCESS: {
      // iterate over the story key within the payload
      const { story } = action.payload;
      const { name, slug, content } = story;
      const {
        component: pageComponent,
        pageTitle,
        metaDescription,
        metadata,
        ogTitle,
        ogDescription,
        themeColor,
        image,
      } = content;

      return {
        ...state,
        loading: false,
        name,
        slug,
        pageComponent,
        pageTitle,
        metaDescription,
        metadata,
        ogTitle,
        ogDescription,
        themeColor,
        image,
        children: parseComponentTree(content),
      };
    }
    case LANDING_PAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
}
